module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving15-50c3abb31bd9d3b2248202cc811cbbe7.jpg";